import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Colors } from "../../style/theme/index";
import { AspectRatio } from "@mui/icons-material";


export const AdminDashboardWrapper = styled(Box)(({ theme }) => ({
  marginTop: "80px",
  ".carousel-wrapper": {
    display: "block",
    width: "100%",
    marginBottom: "20px",
  },

  ".carousel-container": {
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    margin: "10px auto",
    borderRadius: "12px",
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
  },

  ".carousel-content": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: "12px",
    overflow: "hidden",
  },

  ".carousel-slider-container": {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    borderRadius: "12px",
  },

  ".carousel-slider": {
    width: "100%",
    height: "100%",
    display: "flex",
    transition: "transform 0.5s ease-in-out",
    aspectRatio: "16/5",
  },

  ".carousel-slide": {
    position: "relative",
    minWidth: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& a": {
      width: "100%",
    },
  },
  ".carousel-indicators": {
    position: "absolute",
    bottom: "15px",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    zIndex: 5,
    marginBottom: 0,
    "@media (max-width: 480px)": {
      bottom: "10px",
      gap: "6px",
    },
  },

  ".indicator": {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: Colors.garyText,
    cursor: "pointer",
    transition: "all 0.3s",
    margin: 0,
    padding: 0,
    "@media (max-width: 480px)": {
      width: "6px",
      height: "6px",
    },
  },

  ".indicator.active": {
    background: Colors.garyText,
    transform: "scale(1.2)",
  },

  ".carousel-nav-btn": {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: Colors.white,
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "24px",
    color: Colors.garyText,
    zIndex: 5,
    margin: 0,
    padding: 0,
    boxShadow: `0 2px 10px ${Colors.black}1a`,
    transition: "all 0.3s ease",
    border: `1px solid ${Colors.border}`,
    "&:hover": {
      background: Colors.text,
      transform: "translateY(-50%) ",
    },
    "@media (max-width: 768px)": {
      width: "35px",
      height: "35px",
      fontSize: "20px",
    },
    "@media (max-width: 480px)": {
      width: "30px",
      height: "30px",
      fontSize: "18px",
    },
  },

  ".prev-btn": {
    left: "10px",
    "@media (max-width: 480px)": {
      left: "5px",
    },
  },

  ".next-btn": {
    right: "10px",
    "@media (max-width: 480px)": {
      right: "5px",
    },
  },

  ".add-button": {
    position: "absolute",
    top: "20px",
    right: "20px",
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    background: Colors.primary,
    color: Colors.white,
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "20px",
    zIndex: 10,
    boxShadow: `0 4px 8px ${Colors.black}33`,
    transition: "transform 0.3s, background 0.3s",

    "&:hover": {
      background: Colors.hover,
      transform: "scale(1.05)",
    },

    "@media (max-width: 1024px)": {
      top: "20px",
      right: "20px",
    },
    "@media (max-width: 768px)": {
      top: "20px",
      right: "20px",
      width: "44px",
      height: "44px",
      fontSize: "20px",
    },
    "@media (max-width: 480px)": {
      top: "15px",
      right: "15px",
      width: "34px",
      height: "34px",
      fontSize: "20px",
    },
  },

  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(20px) scale(0.8)" },
    to: { opacity: 1, transform: "translateY(0) scale(1)" },
  },

  ".carousel-container img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  ".form-image-container": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
  },

  ".form-image-preview": {
    width: "100%",
    maxWidth: "250px",
    height: "120px",
    objectFit: "cover",
    borderRadius: "6px",
    boxShadow: `0 2px 8px ${Colors.black}1a`,
  },

  ".upload-btn": {
    display: "flex",
    justifyContent: "flex-end",
  },

  ".form-image-upload-btn": {
    backgroundColor: Colors.primary,
    color: Colors.white,
    border: "none",
    padding: "6px 12px",
    marginTop: "10px",
    marginLeft: "270px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: 500,
    fontSize: "0.85rem",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: Colors.hover,
    },
  },

  ".form-field": {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "5px 12px",
  },

  ".form-field label": {
    fontSize: "0.85rem",
    fontWeight: 500,
    color: Colors.garyText,
  },

  ".form-field input,textarea": {
    padding: "6px 10px",
    borderRadius: "4px",
    border: `1px solid ${Colors.border}`,
    fontSize: "0.85rem",
    transition: "border 0.3s ease, box-shadow 0.3s ease",
    "&:focus": {
      outline: "none",
      border: `1px solid ${Colors.primary}`,
      boxShadow: `0 0 0 2px ${Colors.primary}30`,
    },
  },

  ".color-input-container": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& input[type='color']": {
      width: "20px",
      height: "30px",
      border: "none",
      padding: "0",
      cursor: "pointer",
    },
    "& input[type='text']": {
      flex: 1,
    },
  },

  ".form-field textarea": {
    minHeight: "30px",
    resize: "vertical",

  },

  ".form-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
    margin: "12px",
  },

  ".cancel-btn, .save-btn": {
    padding: "6px 12px",
    borderRadius: "4px",
    border: "none",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "0.85rem",
  },

  ".cancel-btn": {
    backgroundColor: Colors.disabled,
    color: Colors.garyText,
    "&:hover": {
      backgroundColor: Colors.light_gray,
    },
  },

  ".save-btn": {
    backgroundColor: Colors.primary,
    color: Colors.white,
    "&:hover": {
      backgroundColor: Colors.hover,
    },
    "&:disabled": {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
    "&.saving": {
      position: "relative",
      color: "transparent",
      "&::after": {
        content: '""',
        position: "absolute",
        width: "16px",
        height: "16px",
        top: "50%",
        left: "50%",
        marginTop: "-8px",
        marginLeft: "-8px",
        border: "2px solid #ffffff",
        borderTopColor: "transparent",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      },
    },
  },

  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },

  "@media (max-width: 480px)": {
    ".form-title": {
      fontSize: "1.2rem",
      marginBottom: "12px",
    },

    ".form-image-preview": {
      height: "100px",
    },

    ".form-field input, .form-field textarea": {
      padding: "5px 8px",
      fontSize: "0.8rem",
    },

    ".form-field textarea": {
      minHeight: "50px",
    },

    ".cancel-btn, .save-btn": {
      padding: "5px 10px",
      fontSize: "0.8rem",
    },
  },

  // Advertisement Banner
  ".ad-banner-container": {
    display: "flex",
    borderRadius: "12px",
    overflow: "hidden",
    margin: "20px 0",
    maxWidth: "100%",
    boxShadow: `0 15px 30px ${Colors.black}26`,
    position: "relative",
  },

  ".ad-banner-content": {
    padding: "40px",
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: Colors.white,

  },

  ".ad-banner-content h2": {
    fontSize: "24px",
    marginBottom: "10px",
    fontWeight: "700",
  },

  ".ad-banner-content p": {
    fontSize: "16px",
    marginBottom: "15px",
    opacity: "0.9",
  },

  ".ad-banner-button": {
    backgroundColor: Colors.white,
    color: Colors.primary,
    border: "none",
    padding: "12px 20px",
    borderRadius: "30px",
    fontWeight: "600",
    fontSize: "16px",
    cursor: "pointer",
    alignSelf: "flex-start",
    boxShadow: `0 5px 15px ${Colors.black}1a`,
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: `0 8px 20px ${Colors.black}26`,
    },
  },

  ".ad-banner-image": {
    borderRadius: "12px",
    flex: "1",
    AspectRatio: "16/6",
    overflow: "hidden",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.5s ease",
      "&:hover": {
        transform: "scale(1.05)",
      },
    },
  },

  // Responsive styles
  "@media (max-width: 992px)": {
    ".ad-banner-container": {
      flexDirection: "column",
    },
    ".ad-banner-image":{
       "&img":{
        width: "100%",
        height: "100%",
        overflow: "hidden",
       }
    }
  },

  "@media (max-width: 768px)": {
    ".carousel-container": {
      height: "40",
    },
  },

  ".banner-form-modal-overlay": {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `${Colors.black}80`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },

  ".banner-form-modal": {
    background: Colors.white,
    borderRadius: "10px",
    width: "85%",
    maxWidth: "400px",
    padding: "0px",
    boxShadow: `0 4px 20px ${Colors.black}26`,
    maxHeight: "80vh",
    overflowY: "auto",
  },
  ".header": {
    display: "flex",
    padding: "10px",
    backgroundColor: Colors.primary,
    color: Colors.white,
    marginBottom: "16px",
  },

  ".bottom-banner-form-modal": {
    marginTop: "20px",
    background: Colors.white,
    borderRadius: "10px",
    width: "85%",
    maxWidth: "500px",
    padding: "0px",
    boxShadow: `0 4px 20px ${Colors.black}26`,
    maxHeight: "80vh",
    overflowY: "auto",
  },

  ".banner-form": {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    paddingInline: "20px",
  },
  "& .color-grid": {
    display: "flex",
    justifyContent: "space-between",
    "& input": {
      width: "100px",
    },
    "@media (max-width : 600px)": {
      flexDirection: "column",
    },
  },

  ".edit-bottom-banner-btn": {
    position: "absolute",
    top: "20px",
    right: "20px",
    width: 44,
    height: 44,
    borderRadius: "50%",
    background: Colors.primary,
    color: Colors.white,
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: 20,
    zIndex: 10,
    boxShadow: `0 4px 8px ${Colors.black}33`,
    transition: "transform 0.3s, background 0.3s",

    "&:hover": {
      background: Colors.hover,
      transform: "scale(1.05)",
    },

    "@media (max-width: 768px)": {
      top: "20px",
      right: "20px",
      width: "44px",
      height: "44px",
      fontSize: "20px",
    },

    "@media (max-width: 480px)": {
      top: "15px",
      right: "15px",
      width: "34px",
      height: "34px",
      fontSize: "20px",
    },
  },

  ".delete-banner-btn": {
    position: "absolute",
    top: "20px",
    right: "75px",
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    background: Colors.delete,
    color: Colors.white,
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "20px",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease",

    "&:hover": {
      background: Colors.hover,
      transform: "scale(1.1)",
    },

    "@media (max-width: 1024px)": {
      top: "20px",
      right: "75px",
    },
    "@media (max-width: 768px)": {
      top: "20px",
      right: "75px",
      width: "44px",
      height: "44px",
      fontSize: "20px",
    },
    "@media (max-width: 480px)": {
      top: "15px",
      right: "60px",
      width: "34px",
      height: "34px",
      fontSize: "20px",
    },
  },

  ".no-image-message": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    color: Colors.garyText,
    fontSize: "18px",
    textAlign: "center",
    padding: "20px",
  },

  ".no-image-icon": {
    fontSize: "48px",
    marginBottom: "10px",
    color: Colors.light,
  },

  ".empty-image-container": {
    width: "100%",
    maxWidth: "250px",
    height: "120px",
    border: `2px dashed ${Colors.border}`,
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: Colors.disabled,
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: Colors.primary,
      backgroundColor: Colors.white,
    },
  },

  ".empty-image-placeholder": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    color: Colors.garyText,
    "& .empty-image-icon": {
      fontSize: "32px",
      color: Colors.light,
    },
    "& p": {
      margin: 0,
      fontSize: "14px",
    },
  },
}));
